import { render, staticRenderFns } from "./LOGOUT.vue?vue&type=template&id=79376697&"
import script from "./LOGOUT.vue?vue&type=script&lang=js&"
export * from "./LOGOUT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports